import validator from "validator";

export const validatePhoneNumber = (phoneNumber: string) => {
  return (
    !validator.isNumeric(phoneNumber) ||
    !validator.isLength(phoneNumber, {
      min: 11,
      max: 11,
    })
  );
};
